var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.19583 22V12.1602H0V8.25H3.19583V5.16914C3.19583 1.82188 5.17917 0 8.075 0C9.4625 0 10.6542 0.107422 11 0.154687V3.65234H8.99167C7.41667 3.65234 7.1125 4.42578 7.1125 5.55586V8.25H10.6667L10.1792 12.1602H7.1125V22","fill":"white"}));
}

Facebook.defaultProps = {"width":"11","height":"22","viewBox":"0 0 11 22","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
